// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3XJE8","legacyBtn":"MutateMid_legacyBtn__2W43Z"};